module.exports = __webpack_public_path__ + "static/media/img6.c3af2583.jpeg";